import { leaseCompanyMst } from '@libs/domain';
import { eligibleBillingProvider } from '@libs/enums';
import { MstMaintenanceTmpl } from '@libs/templates/mst';
import type { PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { AdditionalSearchBasicInfo, leaseCompanyMstColumns } from './components';
import { leaseCompanyMstListSearchFieldConfig } from './item-config';
import { LeaseCompanyMstListSearch } from './models';
import { doExport, listRequest, remove } from './repositories';

function PageComponent(props: PageProps) {
  return (
    <MstMaintenanceTmpl
      mstName={leaseCompanyMst.names.laCompany}
      columns={leaseCompanyMstColumns}
      items={leaseCompanyMstListSearchFieldConfig}
      parsers={{ eligibleBillingProviderCondition: eligibleBillingProvider.toDisplay }}
      listRequestFunction={listRequest}
      initMst={LeaseCompanyMstListSearch.init}
      exportFunction={doExport}
      deleteFunction={remove}
      {...props}
    >
      {AdditionalSearchBasicInfo}
    </MstMaintenanceTmpl>
  );
}

const Maintenance = withRerender(PageComponent, 'Maintenance');

export { Maintenance };
